import { HttpStatusCode } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { IdentityWorkgroupsService } from 'src/app/services/identityWorkgroups.service';
import { LoggingService } from 'src/app/services/logging.service';
import { ToastService } from 'src/app/services/toast.service';



export const deleteWorkgroupModalOptions: NgbModalOptions = {
  keyboard: false,
  centered: true,
  size: 'md',
  windowClass: 'dialog-bg-white'
};


@Component({
  templateUrl: './delete-workgroup.modal.html'
})
export class DeleteWorkgroupModal implements OnInit {

  /** (Guid) Id of the Organisation to verify whether delete is allowed  - Required for delete */
  @Input() organisationGuid!: string;
  /** (Guid) Id of the workgroup to Delete  - Required for delete */
  @Input() workgroupGuid!: string;
  /** Name of the workgroup to Delete - Used to display what the user is about to delete */
  @Input() workgroupName!: string;

  private translations = <any>{};

  constructor(private activeModal: NgbActiveModal, private loggingService: LoggingService, private authenticationService: AuthenticationService, private workgroupService: IdentityWorkgroupsService, private toastService: ToastService, private translateService: TranslateService) {
    this.getTranslations();
    translateService.onLangChange.subscribe(() => {
      this.getTranslations();
    });
  }

  ngOnInit(): void {
    // Must not be empty. It's approved by a comment.
  }

  public closeWithoutDeleting() {
    this.activeModal.close(false);
  }

  public async verifyAndDeleteWorkgroup() {
    (await this.workgroupService.checkAllowWorkgroupDelete(this.organisationGuid, this.workgroupGuid)).subscribe({
      error: (response) => {
        if (response.status == HttpStatusCode.Conflict) {
          this.toastService.showError(this.translations.toastRemoveWorkgroupHeader, this.translations.toastsRemoveWorkgroupErrorConflict);
          this.closeWithoutDeleting();
          return;
        }
        this.toastService.showError(this.translations.toastRemoveWorkgroupHeader, this.translations.toastsRemoveWorkgroupError);
        this.closeWithoutDeleting();
      },
      next: () => {
        // if check returns no error: actually delete the workgroup
        this.DeleteWorkgroup().catch((error) => this.loggingService.logException(error));
      },
    });
  }

  private async DeleteWorkgroup() {
    (await this.workgroupService.deleteWorkgroup(this.organisationGuid, this.workgroupGuid)).subscribe({
      error: () => {
        this.toastService.showError(this.translations.toastRemoveWorkgroupHeader, this.translations.toastsRemoveWorkgroupError);
        this.activeModal.close(true);
      },
      next: () => {
        let index = this.authenticationService.workgroups.findIndex(p => p.Guid == this.workgroupGuid)
        if (index > -1)
          this.authenticationService.workgroups.splice(index, index);
        this.toastService.showSuccess(this.translations.toastDeletedHeader, this.translations.toastsRemoveWorkgroupSuccess);
        this.activeModal.close(true);
      }
    });
  }

  private getTranslations() {
    this.translateService.get([
      'Toasts.RemoveWorkgroupError',
      'Toasts.RemoveWorkgroupErrorConflict',
      'Toasts.RemoveWorkgroupSuccess',
      'Toasts.RemoveWorkgroupHeader',
      'Toasts.Deleted',
    ]).subscribe(translation => {
      this.translations.toastsRemoveWorkgroupError = translation['Toasts.RemoveWorkgroupError'];
      this.translations.toastsRemoveWorkgroupErrorConflict = translation['Toasts.RemoveWorkgroupErrorConflict'];
      this.translations.toastsRemoveWorkgroupSuccess = translation['Toasts.RemoveWorkgroupSuccess'];
      this.translations.toastRemoveWorkgroupHeader = translation['Toasts.RemoveWorkgroupHeader'];
      this.translations.toastDeletedHeader = translation['Toasts.Deleted'];
    });
  }
}
